import { isNotNullOrEmpty, isNotEmptyString, isset } from "./validate"
import {
  // sortBy, prop, compose,
  path
} from "ramda"
//Main
export const PackageDetails = (state) => state.main.packageDetails
export const PackageID = (state) => {
  const packageDetails = state.main.packageDetails
  return path(["hashID"], packageDetails) || path(["idForDisplay"], packageDetails)
}
export const LocationInfo = (state) => state.main.currentLocationInfo
export const ShowPackageDetailsModal = (state) => state.main.showPackageDetailsModal
export const AppConfig = (state) => {
  const appConfig = isNotNullOrEmpty(state.main.appConfig) ? state.main.appConfig : {}
  return {
    titleOptions: path(["nameTitles", "data"], appConfig) || [],
    langOptions: path(["emailLanguages", "data"], appConfig) || [],
    // nobOptions: compose(
    //   (arr) =>
    //     isNotNullOrEmpty(arr)
    //       ? [...arr].sort((a, b) => (a.englishDescription.toLowerCase() > b.englishDescription.toLowerCase() ? 1 : b.englishDescription.toLowerCase() > a.englishDescription.toLowerCase() ? -1 : 0))
    //       : [],
    //   (config) =>
    // )(appConfig),
    nobOptions: path(["natureOfBusiness", "data"], appConfig) || [],

    exchangeRate: path(["exchangeRate"], appConfig) || {}
  }
}

//Landing
export const Timer = (state) => state.landing.timer
export const PaymentInfo = (state) => state.landing.paymentInfo
export const CompanyLandingInfo = (state) => state.landing.companyLandingInfo
export const BRDetails = (state) => state.landing.companyLandingInfo.BRDetails
export const OrderInfo = (state) => state.landing.orderInfo
export const OrderInfoCreationTime = (state) => state.landing.orderInfo?.creationTime
export const OrderFailedTryCount = (state) => (state.landing.orderInfo && isset(state.landing.orderInfo.failedTryCount) ? state.landing.orderInfo.failedTryCount : null)
export const OrderID = (state) => (state.landing.orderInfo && state.landing.orderInfo.id ? state.landing.orderInfo.id : null)
export const TCaptchaResult = (state) => state.landing.tencentCaptchaResult
export const LandingPageInputs = (state) => ({
  email: state.landing.companyLandingInfo.email,
  nameEN: state.landing.companyLandingInfo.nameEN,
  fromSSO: state.landing.companyLandingInfo.fromSSO
})

export const SelectedCountry = (state) => {
  const companyInfo = state.landing.companyLandingInfo
  if (isNotNullOrEmpty(companyInfo) && isNotNullOrEmpty(companyInfo.region) && isNotNullOrEmpty(companyInfo.region.country)) {
    return companyInfo.region.country
  }
  return null
}

export const UserEmail = (state) => {
  const companyInfo = state.landing.companyLandingInfo
  const orderInfo = state.landing.orderInfo
  const emailFromCompanyInfo = path(["email"], companyInfo)
  const emailFromOrderInfo = path(["customer", "contact", "email"], orderInfo)
  if (emailFromOrderInfo && isNotEmptyString(emailFromOrderInfo)) return emailFromOrderInfo
  if (emailFromCompanyInfo && isNotEmptyString(emailFromCompanyInfo)) return emailFromCompanyInfo
  return null
}

//Query
export const Query = (state) => state.main.query
export const Currency = (state) => state.main.query.currency
export const Source = (state) => state.main.query.source

//Upload
export const Upload = (state) => state.upload

//Region
export const Region = (state) => state.region

export const CreateOrderData = (state) => ({
  source: state.main.query.source,
  email: state.landing.companyLandingInfo.email,
  nameEN: state.landing.companyLandingInfo.nameEN,
  SSOUID: state.landing.companyLandingInfo.SSOUID,
  emailFromSSO: state.landing.companyLandingInfo.emailFromSSO,
  nameENFromSSO: state.landing.companyLandingInfo.nameENFromSSO
})

//WebTrack
export const TrackProps = (state) => ({
  companyInfo: state.landing.companyLandingInfo,
  orderInfo: state.landing.orderInfo,
  packageDetails: state.main.packageDetails,
  queries: state.main.query,
  exchangeRate: state.main.appConfig?.exchangeRate || {},
  paymentInfo: state.landing.paymentInfo
})
